import { render, staticRenderFns } from "./commonUploadFile.vue?vue&type=template&id=b9f00dc8&scoped=true&"
import script from "./commonUploadFile.vue?vue&type=script&lang=js&"
export * from "./commonUploadFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f00dc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9f00dc8')) {
      api.createRecord('b9f00dc8', component.options)
    } else {
      api.reload('b9f00dc8', component.options)
    }
    module.hot.accept("./commonUploadFile.vue?vue&type=template&id=b9f00dc8&scoped=true&", function () {
      api.rerender('b9f00dc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/common/commonUploadFile.vue"
export default component.exports